const AboutHyfye = () => {
  return (
    <section id="about" className="small_pt g-9 bg-animated bg-10 ">
       
      <div className="container">
        <div className="row align-items-center">
          {/* Content Section */}
          <div className="col-lg-7 col-md-12 col-sm-12 res_md_mt_40 res_sm_mt_40 res_xs_mt_30">
            <div className="title_dark title_border text_md_center">

              <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                About Hyfye
              </h4>

              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                <strong>Hyfye</strong> stands for <strong>Hybrid Finance for You and Everyone</strong>. It is a Web3 infrastructure ecosystem designed to support real-world utility across finance, gaming, content creation, social media, fitness, marketplaces, and advertising.
              </p>

              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                At the heart of Hyfye is the <strong>HYE token</strong>, the native utility token that powers and connects all Hyfye-based mini-apps and platforms. HYE is about enabling access, utility, and digital ownership in a decentralized economy.
              </p>

              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Hyfye empowers users to engage in a variety of economic activities through a suite of integrated dApps, making participation in the Web3 world simple, measurable, and impactful.
              </p>

              <i className="fa fa-globe animation animated fadeInDown" data-animation="fadeInDown" data-animation-delay="0.1s" 
              style={{animationDelay: "1s","opacity": 1,float: "left",fontSize: "30px",padding: "0px 10px 0px 0px",color: "#0d5dd6"}}></i>
              <h5 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Key Ecosystem Areas
              </h5>

              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Hyfye’s ecosystem spans several sectors:
              
              </p>
                <ul className="margin-left-30">
                  
                  <li><strong>Marketplaces:</strong> Buy/sell with verified listings, digital credentials, and trust-based transactions</li>
                  <li><strong>Finance:</strong> On-chain payments, peer-to-peer transfers, and DeFi access using HYE</li>
                  <li><strong>Gaming:</strong> In-game digital assets, play-to-earn, participation tracking, and player identity</li>
                  <li><strong>Content Creation:</strong> Earn from posts & shares, decentralized engagement, and creator control</li>
                  <li><strong>Fitness & Lifestyle:</strong> Get rewards for daily steps, workouts, and healthy habits</li>
                  <li><strong>Education:</strong> Students earn tokens for school marks and verified achievements</li>
                  <li><strong>Advertising:</strong> Get paid for watching or interacting with ads, with full transparency</li>
                  <li><strong>Social Media:</strong> Real identity, no bots, honest engagement, earn from your network</li>
                  <li><strong>Elders:</strong> Simple tools for seniors to earn and interact in Web3</li>
                  <li><strong>Agriculture & Industry:</strong> Tools for farmers, workers, and industry-level utility</li>

                  </ul>
                   <br/>
              <i className="fa fa-gear animation animated fadeInDown" data-animation="fadeInDown" data-animation-delay="0.1s" 
              style={{animationDelay: "1s","opacity": 1,float: "left",fontSize: "30px",padding: "0px 10px 0px 0px",color: "#0d5dd6"}}></i>
           
              <h5 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Developer-Friendly Infrastructure
              </h5>
              <div className="margin-left-30">

              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Hyfye provides modular SDKs, APIs, and no-code dashboards to help builders launch decentralized apps with real-world use cases. Every transaction is verifiable, every action is recorded, and every participant is empowered.
                <br/>
                Hyfye is more than just another blockchain project — it is the foundational infrastructure for a smarter, more connected digital economy.
                <br/> <br/>
                <strong>Join Hyfye</strong> — Be part of a movement reshaping the internet economy with transparency, usability, and ownership.
              </p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutHyfye;